import {
  BibliographySearchSortKey,
  BibliographySearchSortOrder,
  DisplayMethod,
  SearchTarget
} from '@/types'
import {
  BibliographySearchNarrowCondition,
  BibliographySearchNarrowConditionToJSON,
  defaultBibliographySearchNarrowCondition
} from '@/api'

export interface BibliographyAloneSearchRequest {
  displayMethod: DisplayMethod
  searchTarget: SearchTarget
  numberOfLimit: number
  newPublicationInformationDate: string | undefined
  newPublicationInformationVolume: string | undefined
  collectionNo: string | undefined
  exceptCheckDigit: boolean | undefined
  orderId: string | undefined
  bibliographyClass: string | undefined
  bibliographyId: string | undefined
  isbn: string | undefined
  productNumber: string | undefined
  magazineCode: string | undefined
  marcType: string | undefined
  marcNo: string | undefined
  // ここの値は検索結果一覧の単独検索で行う
  displayBranchCode?: string | undefined
  sortKey: BibliographySearchSortKey
  sortOrder: BibliographySearchSortOrder
  _saveHistory: boolean
  narrow: BibliographySearchNarrowCondition
}

export const defaultBibliographyAloneSearchRequest = (): BibliographyAloneSearchRequest => ({
  displayMethod: DisplayMethod.Simple,
  searchTarget: SearchTarget.Db,
  numberOfLimit: 0,
  newPublicationInformationDate: undefined,
  newPublicationInformationVolume: undefined,
  collectionNo: undefined,
  exceptCheckDigit: undefined,
  orderId: undefined,
  bibliographyClass: undefined,
  bibliographyId: undefined,
  isbn: undefined,
  productNumber: undefined,
  magazineCode: undefined,
  marcType: undefined,
  marcNo: undefined,
  displayBranchCode: undefined,
  sortKey: BibliographySearchSortKey.Title,
  sortOrder: BibliographySearchSortOrder.Unspecified,
  _saveHistory: false,
  narrow: defaultBibliographySearchNarrowCondition()
})

export function BibliographyAloneSearchRequestToJSON(
  value: BibliographyAloneSearchRequest
): any {
  return {
    display_method: value.displayMethod || undefined,
    search_target: value.searchTarget || undefined,
    number_of_limit: value.numberOfLimit || undefined,
    new_publication_information_date: value.newPublicationInformationDate,
    new_publication_information_volume: value.newPublicationInformationVolume,
    collection_no: value.collectionNo,
    except_check_digit: value.exceptCheckDigit,
    order_id: value.orderId,
    bibliography_class: value.bibliographyClass,
    bibliography_id: value.bibliographyId,
    isbn: value.isbn,
    product_number: value.productNumber,
    magazine_code: value.magazineCode,
    marc_type: value.marcType,
    marc_no: value.marcNo,
    display_branch_code: value.displayBranchCode,
    sort_key: value.sortKey !== '' ? value.sortKey : undefined,
    sort_order: value.sortOrder !== '' ? value.sortOrder : undefined,
    _save_history: value._saveHistory ?? undefined,
    narrow: BibliographySearchNarrowConditionToJSON(value.narrow)
  }
}
